/**
 * card-color-swatches.js
 *
 * Wires up the color swatches rendered by snippets/product-swatches.liquid
 * (a.k.a. card-color-swatches.liquid) so that clicking a swatch swaps the
 * card's primary product image ([data-swatch-media-target]).
 *
 * Scope / non-interference guarantees:
 * - Only elements matching [data-swatch] inside [data-swatch-group] are bound.
 * - Only the nearest ancestor .card-wrapper's [data-swatch-media-target] img
 *   is updated (src / srcset / alt). The secondary hover image
 *   (show_secondary_image block) is never touched, since it has no
 *   data-swatch-media-target attribute.
 * - No listeners are attached anywhere else on the card (quick add, price,
 *   badges, etc. are left completely alone).
 * - Uses event delegation on document, so it works for cards injected later
 *   by Dawn's Section Rendering API / infinite scroll without needing a
 *   MutationObserver.
 */
(function () {
  'use strict';

  function updateCardImage(cardWrapper, swatchButton) {
    var img = cardWrapper.querySelector('[data-swatch-media-target]');
    if (!img) return;

    var src = swatchButton.getAttribute('data-swatch-media-src');
    var srcset = swatchButton.getAttribute('data-swatch-media-srcset');
    var alt = swatchButton.getAttribute('data-swatch-media-alt');

    if (!src) return; // nothing to swap to, leave current image as-is

    img.setAttribute('src', src);
    if (srcset) {
      img.setAttribute('srcset', srcset);
    } else {
      img.removeAttribute('srcset');
    }
    if (alt !== null) {
      img.setAttribute('alt', alt);
    }
  }

  function setActiveState(swatchGroup, activeButton) {
    var buttons = swatchGroup.querySelectorAll('[data-swatch]');
    buttons.forEach(function (btn) {
      var isActive = btn === activeButton;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var swatchButton = event.target.closest('[data-swatch]');
    if (!swatchButton) return;

    if (swatchButton.hasAttribute('data-swatch-unavailable')) {
      // Still allow selecting a sold-out swatch's image/state,
      // but you can early-return here instead if you want to block it:
      // return;
    }

    var swatchGroup = swatchButton.closest('[data-swatch-group]');
    var cardWrapper = swatchButton.closest('.card-wrapper');
    if (!swatchGroup || !cardWrapper) return;

    setActiveState(swatchGroup, swatchButton);
    updateCardImage(cardWrapper, swatchButton);
  });
})();
